module.exports = __webpack_public_path__ + "img/453.8875740e.png";